export default {"src":"/_next/static/media/ArrowDownSVG.a668a302.svg","height":8,"width":12};